import { render, staticRenderFns } from "./Relation.vue?vue&type=template&id=b05fc4fa&scoped=true"
import script from "./Relation.vue?vue&type=script&lang=js"
export * from "./Relation.vue?vue&type=script&lang=js"
import style0 from "./Relation.vue?vue&type=style&index=0&id=b05fc4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05fc4fa",
  null
  
)

export default component.exports